class OpalThemeFooter {
    $footer;
    $content;
    constructor() {
        this.init();
    }

    init(){
        if(jQuery('body').hasClass('footer-fixed')){
            this.$footer = jQuery('#colophon');
            this.$content = jQuery('#page');
            this.$footer.css({
                position: 'fixed',
                left: 0,
                bottom: 0,
                zIndex: 0
            })

            this.setup();

            $(window).resize(() => {
                this.setup();
            })
        }
    }

    setup(){
        this.$content.css({
           marginBottom: this.getFooterHeight()
        });
    }

    getFooterHeight(){
        return this.$footer.outerHeight();
    }
}
new OpalThemeFooter();